<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">分配用户</div>
        <el-form
          class="zj-search-form"
          ref="queryForm"
          :model="queryParams"
          :label-width="labelWidth"
        >
          <el-form-item label="用户名称" prop="userName">
            <el-input
              v-model="queryParams.userName"
              placeholder="请输入用户名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="手机号码" prop="phonenumber">
            <el-input
              v-model="queryParams.phonenumber"
              placeholder="请输入手机号码"
            ></el-input>
          </el-form-item>

          <el-form-item label class="right">
            <el-button @click="handleQuery">搜 索</el-button>
            <el-button @click="resetQuery">重 置</el-button>
            <el-button @click="openSelectUser">添加用户</el-button>
            <el-button @click="cancelAuthUserAll" :disabled="multiple">批量取消授权</el-button>
            <el-button @click="close">关闭</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>

      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table v-loading="loading" :data="userList" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55" align="center" />
              <el-table-column label="用户名称" prop="userName"/>
              <el-table-column label="用户昵称" prop="nickName"/>
              <el-table-column label="邮箱" prop="email"/>
              <el-table-column label="手机" prop="phonenumber"/>
              <el-table-column label="状态" align="center" prop="status">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.status == 0">正常</el-tag>
                  <el-tag v-else-if="scope.row.status == 1" type="danger">停用</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="创建时间" align="center" prop="createTime" width="180">
                <template slot-scope="scope">
                  <span>{{ parseTime(scope.row.createTime) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    icon="el-icon-edit-outline"
                    @click="cancelAuthUser(scope.row)"
                  >取消授权</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParams.pageSize"  
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
    <SelectUser ref="select" :roleId="queryParams.roleId" @ok="handleQuery" @confirm="confirmPassword2"></SelectUser>
    
    <!-- 密码二次确认框 -->
    <el-dialog :title="title2" :visible.sync="isShowPasswordDialog" width="600px" append-to-body>
      <el-form ref="form" :model="form2" :rules="rules2" label-width="80px" v-if="isShowPasswordDialog">    
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="用户名称"
              prop="loginName"
            >
              <el-input
                v-model="form2.loginName"
                placeholder="请输入用户名称"
                maxlength="30"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="用户密码"
              prop="password"
            >
              <el-input
                v-model="form2.password"
                placeholder="请输入用户密码"
                type="password"
                maxlength="20"
                show-password
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmPassword">确 定</el-button>
        <el-button @click="cancel2">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { authUserList, cancelAuthAll, cancelAuth} from "@/api/system/permission/role";
import SelectUser from "./SelectUser";
import { login } from "@/api/system/permission/login";
export default {
  name: "RoleUserView",
  controller: "UI",
  action: "RoleUserView",
  components: { SelectUser },
  data() {
    return {
      // 遮罩层
      loading: true,
      // 总条数
      total: 0,
      // 非多个禁用
      multiple: true,
      // 用户表格数据
      userList: [],
      // 查询参数
      queryParams: {
        roleId: null,
        userName: null,
        phonenumber: null,
        pageNum: 1,
        pageSize: 10,
      },
      // 选中用户
      userIds: [],
       isSecondConfirm:false, //红旗坊要求二次输入密码确认
       // 弹出层标题
      title2: "请输入密码",
      isShowPasswordDialog:false,
      form2:{
        loginName: sessionStorage.getItem("userName"),
        password:"",
      },
      rules2: {
        loginName: [
          {
            required: true,
            message: "用户名称不能为空",
            pattern: "[^ \x22]+",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "用户密码不能为空",
            trigger: "blur",
          }
        ],
      },
      confirmType:""
    };
  },
  created() {
    const roleId = this.$route.query && this.$route.query.roleId;
    if (roleId) {
      this.queryParams.roleId = roleId;
      this.getList();
    }
  },
  methods: {
    // 查询已授权用户列表
    getList() {
      this.loading = true;
      authUserList(this.queryParams).then(response => {
        this.userList = response.rows;
        this.total = parseInt(response.total);
        this.loading = false;
      });
    },
    // 搜索
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 选择用户
    openSelectUser() {
      this.$refs.select.show();
    },
    // 批量取消授权
    cancelAuthUserAll() {
      const roleId = this.queryParams.roleId;
      const userIds = this.userIds.join(",");
      let that=this;
      this.$confirm("是否取消选中用户授权数据项?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(function() {
          if(global.$config.app.project=="hongqifang"){
            that.isShowPasswordDialog = true;
            that.confirmType="dellAll"
            // that.currentRow = row;
            // alert( that.isShowPasswordDialog)
            // return
          }else{
             return cancelAuthAll({ roleId: roleId, userIds: userIds });
          }
       
      }).then(() => {
       if(global.$config.app.project!="hongqifang"){
        this.$message({type: "success", message: "批量取消授权成功"});
        this.getList();
       }
      }).catch(() => {});
    },
    // 关闭
    close() {
      this.$router.go(-1);
    },

    // 多选框选中
    handleSelectionChange(selection) {
      console.log("selection")
      console.log(selection)
      this.userIds = selection.map(item => item.userId)
      this.multiple = !selection.length;
      console.log(this.userIds)
    },
    // 行取消授权
    cancelAuthUser(row) {
      const roleId = this.queryParams.roleId;
      let that=this;
      this.$confirm("是否取消该用户授权?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(function() {
          if(global.$config.app.project=="hongqifang"){
            that.isShowPasswordDialog = true;
            that.confirmType="dell"
            that.currentRow = row;
            // alert( that.isShowPasswordDialog)
            // return
          }else{
             return cancelAuth({ roleId: roleId, userId: row.userId });
          }
       
      }).then(() => {
        if(global.$config.app.project!="hongqifang"){
          this.$message({type: "success", message: "取消授权成功"});
          this.getList();
        }
      }).catch(() => {});
    },
    
    // 点击每页显示的条数
    handleSizeChange(val){
      this.queryParams.pageSize = val;
      this.getList();
    },
    // 点击切换到某页
    handleCurrentChange(val){
      this.queryParams.pageNum = val;
      this.getList();
    },
    confirmPassword(){
      let that = this;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          login(this.form2).then((res) => {
            console.log("登录结果",res)
            if(res.code==0||res.code==200){
              that.isSecondConfirm=true;
               that.cancel2();
               if(that.confirmType=="dell"){
                  const roleId = that.queryParams.roleId;
                 cancelAuth({ roleId: roleId, userId: that.currentRow.userId }).then(res=>{
                  //  console.log("删除res",res)
                   if(res.code==200){
                     that.$message({type: "success", message: "取消授权成功"});
                     that.confirmType="";
                     that.getList()
                   }else{
                     that.confirmType="";
                   }
                 })
               }else if(that.confirmType=="dellAll"){
                 const roleId = that.queryParams.roleId;
                 const userIds = that.userIds.join(",");
                 console.log("that.userIds")
                 console.log(that.userIds)
                 cancelAuthAll({ roleId: roleId, userIds: userIds }).then(res=>{
                  //  console.log("删除res",res)
                   if(res.code==200){
                     that.$message({type: "success", message: "取消授权成功"});
                     that.confirmType="";
                     that.getList()
                   }else{
                     that.confirmType="";
                   }
                 })
               }else if(that.confirmType=="addUser"){
                  this.$refs.select.handleSelectUser()
               }
               
            }
          });
        }
      });
    },
      // 取消按钮
    cancel2() {
      this.isShowPasswordDialog = false;
      this.form2.password = "";
    },
    confirmPassword2(){
      this.isShowPasswordDialog=true;
      this.confirmType="addUser";
    }
  },
};
</script>
